export default "__VITE_PUBLIC_ASSET__aaf1e1e9__"